import { AdvancedImage } from "@cloudinary/react";
import { fill } from "@cloudinary/url-gen/actions/resize";
import DOMPurify from "dompurify";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { Editor } from "primereact/editor";
import { FileUpload } from "primereact/fileupload";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { RadioButton } from "primereact/radiobutton";
import { TabPanel, TabView } from "primereact/tabview";
import { useEffect, useRef, useState } from "react";
import localeText from "../../../../locale";
import ProductService from "../../../../service/ProductService";
import { cloudinaryInstance } from "../../../../utilities/Cloudinary/cloudinaryInstance";
import { handleDescriptionLocale } from "../../../../utilities/locale/handleDescriptionLocale";
import { locale } from "../../../../utilities/locale/locale";
import { localeISO } from "../../../../utilities/localeIso";
import { useToastContext } from "../../../../contexts/ToastContext/ToastContext";
import { useLocation, useHistory } from "react-router-dom";
import GetUserInfoService from "../../../../service/GetUserInfoService";

const uploadOptions = {
  className: "hidden",
};

const FringeBenefitEdit = () => {
  const getUserInfoService = new GetUserInfoService();
  const productService = new ProductService();

  const location = useLocation();

  const [product, setProduct] = useState();

  const downloadableId = parseInt(process.env.REACT_APP_DOWNLOADABLE_ID);

  const [typeProduct, setTypeProduct] = useState();
  const [specificCategories, setSpecificCategories] = useState([]);
  const [images, setImages] = useState([]);
  const [originalImages, setOriginalImages] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [image1, setImage1] = useState(null);
  const [title, setTitle] = useState();
  const [rules, setRules] = useState();
  const [price, setPrice] = useState();

  const [loadingCategories, setLoadingCategories] = useState(true);
  const [loading, setLoading] = useState(true);
  const [loadingSubmit, setLoadingSubmit] = useState(false);

  const navigate = useHistory();

  const [stock, setStock] = useState();

  const { showErrorToast, showSuccessToast } = useToastContext();

  const fileUploadRef1 = useRef(null);

  // Dynamic properties (depend on subcategory / sendShip checkbox on register product)
  const [types, setTypes] = useState([]);
  const [type, setType] = useState(null);

  const [categories, setCategories] = useState([]);
  const [category, setCategory] = useState(null);
  const [subcategories, setSubcategories] = useState([]);
  const [subcategory, setSubcategory] = useState(null);

  async function fetchCategories(productObj) {
    try {
      setLoadingCategories(true);

      const resCategories = await productService.getCategories();

      if (resCategories.messageCode !== 200001) {
        showErrorToast({ code: resCategories.messageCode });

        return false;
      } else {
        const categoriesObjArr = [];

        resCategories.result.forEach((category) => {
          const categoryObj = {
            label:
              locale === "en"
                ? category.descriptionEnglish
                : locale === "it"
                ? category.descriptionItalian
                : locale === "pt"
                ? category.descriptionPortuguese
                : category.descriptionSpanish,
            imageid: category.imageid,
            id: category.id,
            subCategories: category.subCategories,
          };

          categoriesObjArr.push(categoryObj);
        });

        const category = categoriesObjArr.find((category) =>
          category.subCategories.find((subcategory) => subcategory.id === productObj.subCategory.id)
        );

        const subcategoriesObjArr = [];

        category.subCategories.forEach((subcategory) => {
          const subcategoryObj = {
            label:
              locale === "en"
                ? subcategory.descriptionEnglish
                : locale === "it"
                ? subcategory.descriptionItalian
                : locale === "pt"
                ? subcategory.descriptionPortuguese
                : subcategory.descriptionSpanish,
            imageid: subcategory.imageid,
            id: subcategory.id,
          };

          subcategoriesObjArr.push(subcategoryObj);
        });

        const subcategory = subcategoriesObjArr.find(
          (subcategory) => subcategory.id === productObj.subCategory.id
        );

        let specificCategories;

        if (typeProduct !== 3) {
          specificCategories = categoriesObjArr.filter(
            (category) => category.id !== downloadableId
          );
        } else {
          specificCategories = categoriesObjArr.filter(
            (category) => category.id === downloadableId
          );
        }

        setCategories(categoriesObjArr);
        setSpecificCategories(specificCategories);
        setCategory(category);
        setSubcategories(subcategoriesObjArr);
        setSubcategory(subcategory);
      }
    } catch (e) {
      if (e.status === 401 || e.status === 403) {
        localStorage.removeItem("__extraconomy_token");
        localStorage.removeItem("__extraconomy_username");
        window.location.replace("/login");
      }
      console.log(e);
    } finally {
      setLoadingCategories(false);
    }
  }

  const handleChangeCategory = (e) => {
    setCategory(e.value);

    const subcategoriesObjArr = [];

    e.value?.subCategories?.forEach((subcategory) => {
      const subcategoryObj = {
        label:
          locale === "en"
            ? subcategory.descriptionEnglish
            : locale === "it"
            ? subcategory.descriptionItalian
            : locale === "pt"
            ? subcategory.descriptionPortuguese
            : subcategory.descriptionSpanish,
        imageid: subcategory.imageid,
        id: subcategory.id,
      };

      subcategoriesObjArr.push(subcategoryObj);
    });

    setSubcategories(subcategoriesObjArr);
    setSubcategory(subcategoriesObjArr[0]);
  };

  function changeSelectedImage(index) {
    const deselectedImageElem = document.getElementById(`pi${currentImageIndex}`);
    deselectedImageElem.style.backgroundColor = "initial";
    deselectedImageElem.style.border = "1px solid #E0E0E0";

    const imageElem = document.getElementById(`pi${index}`);
    imageElem.style.backgroundColor = "#272360";
    imageElem.style.border = "1px solid #272360";

    setCurrentImageIndex(index);
  }

  async function uploadImages(image) {
    try {
      if (image && typeof image !== "string") {
        const res = await productService.postUploadImage(
          localStorage.getItem("__extraconomy_token"),
          image
        );
        if (res.messageCode !== 200000) {
          showErrorToast({ code: res.messageCode });

          return false;
        } else {
          return res.result;
        }
      } else {
        return null;
      }
    } catch (e) {
      if (e.status === 401) {
        localStorage.removeItem("__extraconomy_token");
        localStorage.removeItem("__extraconomy_username");
        window.location.replace("/login");
      } else if (e.status === 500) {
        showErrorToast({ detail: "unexpectedSystemBehaviour" });
      } else {
        showErrorToast({ detail: "unexpectedErrorUploadImg" });
      }
    }
  }

  async function confirmChanges() {
    try {
      setLoadingSubmit(true);

      if (stock === 0) {
        showErrorToast({ detail: "stockGreaterThanZero" });

        return;
      }

      if (title.length === 0 || rules.length === 0 || !price || price === 0) {
        showErrorToast({ detail: "pleaseFillOutAll" });

        return;
      }

      const imagesUpload = [];

      if (images[0]) imagesUpload[0] = await uploadImages(images[0]);

      const data = {
        title: title,
        rules: rules,
        imageid1: imagesUpload[0] ? imagesUpload[0] : originalImages[0],
        productStatus: product.productStatus,
        currency: product.currency,
        amountAvailable: stock,
        username: product.user.username,
        subCategoryId: subcategory.id,
        price: price,
        id: product.id,
      };

      const resEdit = await productService.editFringeBenefit(data);

      if (resEdit.messageCode !== 200000) {
        showErrorToast({ code: resEdit.messageCode });

        if (resEdit.messageCode === 500000) console.log(resEdit);
        return;
      }

      showSuccessToast({ detail: "successEditFringeBenefit" });
    } catch (e) {
      if (e.status === 401 || e.status === 403) {
        localStorage.removeItem("__extraconomy_token");
        localStorage.removeItem("__extraconomy_username");
        window.location.replace("/login");
      }
      console.log(e);
    } finally {
      setLoadingSubmit(false);
    }
  }

  const renderHeader = () => {
    return (
      <span className="ql-formats">
        <select className="ql-size">
          <option defaultValue="">{localeText("normal")}</option>
          <option value="huge">{localeText("heading")}</option>
          <option value="large">{localeText("subheading")}</option>
        </select>
        <span className="ql-formats">
          <button className="ql-bold" aria-label="Bold"></button>
          <button className="ql-italic" aria-label="Italic"></button>
          <button className="ql-underline" aria-label="Underline"></button>
        </span>
        <span className="ql-formats">
          <button type="button" className="ql-list" value="ordered" aria-label="Ordered List">
            <svg viewBox="0 0 18 18">
              {" "}
              <line className="ql-stroke" x1="7" x2="15" y1="4" y2="4"></line>{" "}
              <line className="ql-stroke" x1="7" x2="15" y1="9" y2="9"></line>{" "}
              <line className="ql-stroke" x1="7" x2="15" y1="14" y2="14"></line>{" "}
              <line className="ql-stroke ql-thin" x1="2.5" x2="4.5" y1="5.5" y2="5.5"></line>{" "}
              <path
                className="ql-fill"
                d="M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z"
              ></path>{" "}
              <path
                className="ql-stroke ql-thin"
                d="M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156"
              ></path>{" "}
              <path
                className="ql-stroke ql-thin"
                d="M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109"
              ></path>{" "}
            </svg>
          </button>
          <button type="button" className="ql-list" value="bullet" aria-label="Unordered List">
            <svg viewBox="0 0 18 18">
              {" "}
              <line className="ql-stroke" x1="6" x2="15" y1="4" y2="4"></line>{" "}
              <line className="ql-stroke" x1="6" x2="15" y1="9" y2="9"></line>{" "}
              <line className="ql-stroke" x1="6" x2="15" y1="14" y2="14"></line>{" "}
              <line className="ql-stroke" x1="3" x2="3" y1="4" y2="4"></line>{" "}
              <line className="ql-stroke" x1="3" x2="3" y1="9" y2="9"></line>{" "}
              <line className="ql-stroke" x1="3" x2="3" y1="14" y2="14"></line>{" "}
            </svg>
          </button>
        </span>
      </span>
    );
  };

  const header = renderHeader();

  useEffect(() => {
    if (categories.length > 0 && subcategory) {
      setTypes([]);
      setType(null);

      const subcategoryFull = category.subCategories.find((subcat) => subcat.id === subcategory.id);

      if (subcategoryFull && subcategoryFull.brands.length > 0) {
        const brandsArr = [];

        subcategoryFull.brands.forEach((brand) => {
          const brandObj = { label: brand.rules, id: brand.id };
          brandsArr.push(brandObj);
        });
      }

      if (subcategoryFull && subcategoryFull.types.length > 0) {
        const typesArr = [];

        subcategoryFull.types.forEach((type) => {
          let labelDescription = handleDescriptionLocale(type);

          const typeObj = {
            label: labelDescription,
            id: type.id,
          };

          typesArr.push(typeObj);
        });

        setTypes(typesArr);
        product.product.type
          ? setType({
              label: handleDescriptionLocale(product.product.type),
              id: product.product.type.id,
            })
          : setType(typesArr[0]);
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subcategory]);

  useEffect(() => {
    const handleChangeCategory = () => {
      let specificCategories;
      if (typeProduct !== 3) {
        specificCategories = categories.filter((category) => category.id !== downloadableId);
      } else {
        specificCategories = categories.filter((category) => category.id === downloadableId);
      }

      const subcategoriesObjArr = [];
      specificCategories[0]?.subCategories?.forEach((subcategory) => {
        const subcategoryObj = {
          label:
            locale === "en"
              ? subcategory.descriptionEnglish
              : locale === "it"
              ? subcategory.descriptionItalian
              : locale === "pt"
              ? subcategory.descriptionPortuguese
              : subcategory.descriptionSpanish,
          imageid: subcategory.imageid,
          id: subcategory.id,
        };

        subcategoriesObjArr.push(subcategoryObj);
      });

      setSpecificCategories(specificCategories);
      setCategory(specificCategories[0]);
      setSubcategories(subcategoriesObjArr);
      setSubcategory(subcategoriesObjArr[0]);
    };

    if (categories && categories.length > 0) handleChangeCategory(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [typeProduct]);

  useEffect(() => {
    const fetchProduct = async () => {
      const params = new URLSearchParams(location.search);

      const productId = params.get("productId");

      const res = await getUserInfoService.getFringeBenefit(productId);

      if (res.messageCode !== 200001) {
        showErrorToast({ code: res.messageCode });
      }

      const product = res.result;

      const arrImages = [];

      product.imageid1 ? (arrImages[0] = product.imageid1) : (arrImages[0] = null);

      setImages(arrImages);
      setOriginalImages(arrImages);
      setProduct(res.result);
      setTitle(product?.title);
      setPrice(product?.price);
      setRules(product?.rules);
      setStock(product?.amountAvailable);

      await fetchCategories(product);

      setLoading(false);
    };

    fetchProduct();
  }, [location.search]);

  const goToVouchersList = () => {
    navigate.push("/dashboard-list-fringe-benefit");
  };

  return (
    <div>
      <Button
        icon="pi pi-arrow-left"
        onClick={goToVouchersList}
        label={localeText("goBackVouchersList")}
        className="mt-4"
      />

      <h3 className="mb-4">
        {localeText("editProduct")} "{product?.title}"
      </h3>
      <hr />

      {product ? (
        <div>
          {loading ? (
            <i className="pi pi-spin pi-spinner text-600 text-xl my-2"></i>
          ) : (
            <>
              {typeProduct && (
                <div className="flex flex-wrap gap-3 my-4">
                  <div className="flex align-items-center">{localeText("typeOfProduct")}</div>
                  <div className="flex align-items-center">
                    <RadioButton
                      inputId="type1"
                      name="product"
                      value={1}
                      onChange={(e) => setTypeProduct(e.value)}
                      checked={typeProduct === 1}
                    />
                    <label htmlFor="type1" className="ml-2 cursor-pointer">
                      {localeText("product")}
                    </label>
                  </div>
                  <div className="flex align-items-center">
                    <RadioButton
                      inputId="type2"
                      name="product"
                      value={2}
                      onChange={(e) => setTypeProduct(e.value)}
                      checked={typeProduct === 2}
                    />
                    <label htmlFor="type2" className="ml-2 cursor-pointer">
                      {localeText("service")}
                    </label>
                  </div>
                  <div className="flex align-items-center">
                    <RadioButton
                      inputId="type3"
                      name="product"
                      value={3}
                      onChange={(e) => setTypeProduct(e.value)}
                      checked={typeProduct === 3}
                    />
                    <label htmlFor="type3" className="ml-2 cursor-pointer">
                      {localeText("downloadable")}
                    </label>
                  </div>
                </div>
              )}

              {!loadingCategories && categories?.length > 0 && (
                <>
                  <label htmlFor="categories">{localeText("category")}:</label>
                  <Dropdown
                    name="categories"
                    value={category}
                    options={specificCategories}
                    style={{ minWidth: "200px" }}
                    onChange={handleChangeCategory}
                    className="ml-2 mr-4 mb-4 lg:mt-0 mt-2"
                  />
                </>
              )}

              {subcategories?.length > 0 && (
                <>
                  <br className="lg:hidden md:hidden block"></br>
                  <label htmlFor="subcategories">{localeText("subcategory")}:</label>
                  <Dropdown
                    name="subcategories"
                    value={subcategory}
                    options={subcategories}
                    onChange={(e) => setSubcategory(e.value)}
                    className="ml-2 mb-4 lg:mt-0 mt-2"
                    style={{ minWidth: "200px" }}
                  />
                </>
              )}
            </>
          )}

          <h5 className="mb-3 mt-0">{localeText("productImages")}</h5>

          <ul className="my-0 p-0 list-none flex flex-wrap justify-content-center align-items-center">
            <li
              className="flex justify-content-end mb-4 mx-2"
              onClick={() => changeSelectedImage(0)}
            >
              <div
                style={{
                  border: "1px solid #E0E0E0",
                  outline: "2px solid #f7b005",
                  outlineOffset: "2px",
                }}
                className="border-round p-2 product-thumbnail"
                id={`pi0`}
              >
                {image1 ? (
                  <div
                    className="lg:h-15rem lg:w-15rem md:h-10rem md:w-10rem h-5rem w-5rem bg-cover bg-center"
                    style={{ background: `url(${image1.objectURL})` }}
                  ></div>
                ) : (
                  <>
                    <div className="flex absolute justify-content-center align-items-center lg:h-15rem lg:w-15rem md:h-10rem md:w-10rem h-5rem w-5rem">
                      <i className="pi pi-pencil text-2xl bg-primary border-3 border-0 border-circle p-3"></i>
                    </div>
                    <AdvancedImage
                      cldImg={cloudinaryInstance
                        .image(images[0])
                        .resize(fill().width(600).height(600))
                        .format("webp")}
                      className="lg:h-15rem md:h-10rem h-5rem"
                    />
                  </>
                )}
              </div>
            </li>
          </ul>

          <TabView
            activeIndex={currentImageIndex}
            onTabChange={(e) => changeSelectedImage(e.index)}
          >
            <TabPanel
              header={
                <div className="flex align-items-center">
                  <i className="pi pi-pencil mr-2"></i>
                  {localeText("image")} 1
                </div>
              }
            >
              {image1 ? (
                <div className="flex justify-content-center">
                  <Button
                    icon="pi pi-times"
                    className="p-button-danger p-button-rounded my-6 py-3 px-5 text-1xl"
                    onClick={() => {
                      const arrImages = [...images];
                      arrImages[0] = originalImages[0];
                      setImage1(null);
                      setImages(arrImages);
                    }}
                    label={localeText("removeImage")}
                  />
                </div>
              ) : (
                <FileUpload
                  uploadOptions={uploadOptions}
                  chooseLabel={localeText("choose")}
                  cancelLabel={localeText("cancel")}
                  name="demo"
                  onSelect={(e) => {
                    if (e.files[0].size / 1024 / 1024 > 5) {
                      fileUploadRef1.current.clear();
                      showErrorToast({ detail: "fileSizeTooBig" });

                      return false;
                    }

                    const arrImages = [...images];
                    arrImages[0] = e.files[0];
                    setImages(arrImages);
                    setImage1(e.files[0]);
                  }}
                  onClear={() => {
                    const arrImages = [...images];
                    arrImages[0] = originalImages[0];
                    setImage1(null);
                    setImages(arrImages);
                  }}
                  onRemove={() => {
                    fileUploadRef1.current.clear();
                    const arrImages = [...images];
                    arrImages[0] = originalImages[0];
                    setImage1(null);
                    setImages(arrImages);
                  }}
                  onError={() => {
                    fileUploadRef1.current.clear();
                    const arrImages = [...images];
                    arrImages[0] = originalImages[0];
                    setImage1(null);
                    setImages(arrImages);
                  }}
                  onValidationFail={() => {
                    fileUploadRef1.current.clear();
                    const arrImages = [...images];
                    arrImages[0] = originalImages[0];
                    setImage1(null);
                    setImages(arrImages);
                  }}
                  accept="image/*"
                  ref={fileUploadRef1}
                  emptyTemplate={
                    <div className="text-center">
                      <i className="pi pi-upload text-400" style={{ fontSize: "2em" }}></i>
                      <h5 className="text-400">{localeText("dragImgFile")}</h5>
                    </div>
                  }
                  className="w-full h-auto"
                />
              )}
            </TabPanel>
          </TabView>

          <div className="my-4">
            <div className="grid">
              <div className="lg:col-6 md:col-6 col-12 w-full">
                <ul className="list-none m-0 p-0">
                  <li>
                    <label htmlFor="title">{localeText("title")}</label>
                  </li>
                  <li className="mt-2">
                    <InputText
                      className="w-full"
                      name="title"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                    />
                  </li>
                </ul>
              </div>
            </div>

            <label htmlFor="rules">{localeText("rulesToUse")}</label>

            <Editor
              headerTemplate={header}
              value={rules}
              className="my-2"
              onTextChange={(e) => setRules(DOMPurify.sanitize(e.htmlValue))}
              style={{ height: "256px", background: "#fff" }}
            />

            <div className="w-full">
              <label htmlFor="price">{localeText("price")}:</label>

              <InputNumber
                mode="currency"
                currency={product?.currency}
                locale={localeISO}
                className="w-full my-2"
                name="price"
                value={price}
                onValueChange={(e) => setPrice(e.value)}
              />
            </div>

            <div className="w-full">
              <label htmlFor="stock">{localeText("availableStock")}</label>

              <InputNumber
                className="w-full my-2"
                name="stock"
                value={stock}
                onValueChange={(e) => setStock(e.value)}
              />
            </div>
          </div>

          <div className="text-center mb-6">
            <Button
              label={localeText("confirmChanges")}
              onClick={confirmChanges}
              loading={loadingSubmit}
            />
          </div>
        </div>
      ) : (
        <>
          <div className="flex justify-content-center align-items-center">
            <i className="pi pi-spin pi-spinner text-600 text-xl my-2"></i>
          </div>
        </>
      )}
    </div>
  );
};

export default FringeBenefitEdit;
